import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { getCurrentUser } from 'aws-amplify/auth';
import { SharedService } from '../../layouts/shared-service';
import { AnalysisDetails, DropDown, SearchResult } from '../../model/analysis-details.model';
import { DropDownService } from '../../service/drop-down.service';
import { AuthService, DBService } from '../../service';
import { User } from '../../model/types';
import { Router } from '@angular/router';
import { MatChipInputEvent } from '@angular/material/chips';
import { COMMA, ENTER, SPACE, } from '@angular/cdk/keycodes';
import moment from 'moment';
import { AuthNewService } from '../../service/auth-new.service';
import { delay } from 'rxjs/operators';


@Component({
    selector: 'app-new-analysis',
    templateUrl: './new-analysis.component.html',
    styleUrls: ['./new-analysis.component.scss'],
    standalone: false
})
export class NewAnalysisComponent implements OnInit {

  pageTitle = 'Analyze Report/Data';
  signedInUser: User;
  analysisFormGroup: FormGroup;
  analysisFormGroup_AP: FormGroup;
  lts80_dialog: FormControl = new FormControl();
  analysisDetails: AnalysisDetails;
  post: any = '';

  pattern1 = '^([a-zA-Z0-9., :-])*([a-zA-Z0-9., :-])+?$';
  stdConc_pattern = '^[-]?[0-9]+([,.][0-9]+)?$';
  stdConc_validator: boolean;

  readonly separatorKeysCodes: number[] = [ENTER, COMMA, SPACE];

  Tags: string[] = [];
  maxDate;
  multipleAnalyteError = false;
  addOnBlur = true;

  constructor(
      private formBuilder: FormBuilder,
      private _sharedService: SharedService,
      private authService: AuthNewService,
      private router: Router,
      private dbService: DBService,
      private dropDownService: DropDownService,
      private newAuthService: AuthNewService,
      private ref: ChangeDetectorRef
  ) {
      this._sharedService.emitChange(this.pageTitle);
  }

  ngOnInit() {
    const currentDate = moment().toDate();
    this.maxDate = currentDate;
    getCurrentUser().then(data => {
      this.signedInUser = new User(true, data.username, data.userId);
    }).catch(e => {
      this.router.navigate(['/extra-layout/signin']);
      return;
    });
    this.authService.setUserData();
    this.createForm();
  }

  createForm() {
    this.analysisFormGroup = this.formBuilder.group({
      analysisType: [null, Validators.required],
    });

    this.analysisFormGroup_AP = this.formBuilder.group({
      analyteName: ['', [Validators.pattern(this.pattern1), Validators.maxLength(50), Validators.required]],
      analysisType: ['AP'],
      analysisSubtype: ['logistic'],
      projectCode_AP: ['', [Validators.pattern(this.pattern1), Validators.maxLength(50), Validators.required]]
    })

    this.ref.detectChanges();
  }

  get formControls() { return this.analysisFormGroup.controls; }

  get formControlsAP() { return this.analysisFormGroup_AP.controls; }

  onSubmit(post) {
    // console.log('Submit for Analysis')
    // tslint:disable-next-line: max-line-length
    this.analysisDetails = Object.assign({}, this.analysisFormGroup_AP.value);
    this.analysisDetails.userId = this.signedInUser.username;
    this.analysisDetails.userPrefix = this.authService.currentUsername;
    this.analysisDetails.userEmail = this.authService.currentEmail;
    this.analysisDetails.analysisId = (new Date).getTime().toString();
    this.post = post;
  }

  resetAnalysis() {
    // console.log('RESET Called');
  }

  getDisplayString(key) {
    return this.dropDownService.nameDescMap.get(key);
  }

  getDropDownValues(key) {
    return this.dropDownService.dropDownsMap.get(key);
  }
}
